<script lang="ts">
    import { empty } from "svelte/internal";

  export let key: string;
</script>

{#if key === 'gridSize'}
  The exact size of the grid, from 3 to 35.
{:else if key === 'gridSizeLabel'}
  The category of size of the grid, can be
  <span class="code">extra small</span>,
  <span class="code">small</span>,
  <span class="code">normal</span>,
  <span class="code">large</span>,
  <span class="code">extra large</span>
  .
{:else if key === 'numberOfGenerations'}
  The number of generations of cells.
{:else if key === 'tileQty'}
  The number of tiles (max 35*35 = 1225).
{:else if key === 'emptySlots'}
  The number of empty slots.
{:else if key === 'density'}
  The density (max 100).
{:else if key === 'mutations'}
  The number of mutations that occured.
{:else if key === 'numberOfColors'}
  Different colors (1 to 5).
{:else if key === 'singleColor'}
  Has only one color.
{:else if key === 'vertical'}
  Number of vertical tiles.
{:else if key === 'horizontal'}
  Number of horizontal tiles.
{:else if key === 'onlyVertical'}
  Only vertical tiles.
{:else if key === 'onlyHorizontal'}
  Only horizontal tiles.
{:else if key === 'simplestTiles'}
  Quantity of most simple tiles: empty square.
{:else if key === 'diagonal'}
  There are tiles only on one diagonal.
{:else if key === 'line'}
  There are tiles only on one line or column.
{:else if key === 'diagonalLimit'}
  A diagonal of tiles splits the pattern.
{:else if key === 'onlyOneFilled'}
  Only 1 tile.
{:else if key === 'onlyOneEmpty'}
  Only 1 tile empty.
{:else if key === 'full'}
  The grid is full (density 100).
{:else if key === 'NOIR_HD'}
  Black tiles.
{:else if key === 'VIOLET'}
  Violet tiles.
{:else if key === 'BLEU_FRANC'}
  Clear blue tiles.
{:else if key === 'BLEU'}
  Blue tiles.
{:else if key === 'AQUA'}
  Aqua blue tiles.
{:else if key === 'VERT_CANARD'}
  Duck green tiles.
{:else if key === 'VERT'}
  Green tiles.
{:else if key === 'VERT_FLUO'}
  Flashy green tiles.
{:else if key === 'JAUNE'}
  Yellow tiles.
{:else if key === 'ORANGE'}
  Orange tiles.
{:else if key === 'ORANGE_FLUO'}
  Flashy orange tiles.
{:else if key === 'ROSE_FLUO'}
  Flashy pink tiles.
{:else if key === 'ROUGE_BRILLANT'}
  Bright red tiles.
{:else if key === 'DORE_METALLISE'}
  Metallic gold tiles.
{:else}
  TODO
{/if}


<style>
  .code, th[scope='row'] {
    font-style: italic;
  }
</style>